export default __webpack_public_path__ + "static/media/added-text-instruction.9622ba09.svg";